import { Field, SelectField } from "payload"
import { TbBrandTelegram, TbSettings } from "react-icons/tb";
import { HiLink, HiOutlineDocumentCheck } from "react-icons/hi2"


export const SvgIcons = { // narrowing down, otherwise generates too big type
    Telegram: TbBrandTelegram,
    Link: HiLink,
    Document: HiOutlineDocumentCheck,
    Settings: TbSettings,
}

export type IconName = keyof typeof SvgIcons

export const availableIcons = Object.keys(SvgIcons).map((key) => ({
    label: key.replace(/([A-Z])/g, " $1").trim(),
    value: key as IconName,
}))

export const SvgIconField = (props?: Partial<Omit<SelectField, "type" | "hasMany" | "options">>) =>
    ({
        type: "select",
        label: "Векторная иконка",
        options: Object.keys(SvgIcons),
        interfaceName: "SvgIcon",
        ...props,
        name: props?.name ?? "icon"
    }) as Field
